export default __webpack_public_path__ + "static/media/alexandra-han.d3e4bfb7.png";